import ErrorService from "services/error.service";
// import SentryService from "services/sentry.service";
// import OneSignalService from "services/onesignal.service";

const InitializationService = {
	init: () => {
		ErrorService.init();
		// SentryService.init();
		// OneSignalService.init();
	},
};

export default InitializationService;
